import {
  SliderBreakpoint,
  SliderConfiguration,
  SliderConfigurationParams,
} from './types';
import { DEFAULT_CONTAINER_WIDTH, DEFAULT_SPACING } from './constants';

const getBreakpointForScreenWidth = (
  breakpoints: SliderBreakpoint[],
  screenWidth: number
) =>
  breakpoints
    .slice()
    .reverse()
    .find(point => screenWidth >= point.maxWidth) || breakpoints[0];

// read cookie with the screen width to get the expected column sizes
export const getSliderConfiguration = ({
  breakpoints,
  containerWidth = DEFAULT_CONTAINER_WIDTH,
  screenWidth,
  dontScale,
}: SliderConfigurationParams): SliderConfiguration => {
  const elementSpacing = DEFAULT_SPACING;
  const { elementWidth, elementHeight } = getBreakpointForScreenWidth(
    breakpoints,
    screenWidth
  );
  if (dontScale) {
    return {
      elementWidth,
      elementHeight,
    };
  }

  const ratio = elementHeight ? elementWidth / elementHeight : 0;

  // We try to place X elements per row such that width of elements is as close
  // to targetWidth as possible, but not greater
  const elementsPerRow = Math.max(
    1,
    Math.floor(
      (containerWidth + elementSpacing) / (elementWidth + elementSpacing)
    )
  );
  const adjustedElementWidth =
    (containerWidth + elementSpacing) / elementsPerRow - elementSpacing;
  const adjustedElementHeight = adjustedElementWidth / ratio;

  return {
    elementWidth: adjustedElementWidth,
    elementHeight: adjustedElementHeight,
  };
};
